const mEditionBillingMyPaymentsInvoiceHistory = {
  mEditionBillingMyPaymentsInvoiceHistory: {
    alerts: {
      readPagosExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de pagos descargado.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      download: {
        text: 'Exportar',
        subText: 'Formato'
      },
      filterText: 'Filtros Avanzados'
    },

    files: {
      sales: 'pagos'
    },

    table: {
      thAmount: 'MONTO',
      thDate: 'FECHA',
      thDetail: 'DETALLE',
      thDiscount: 'DESCUENTO',
      thInvoice: 'COMPROBANTE',
      thMethod: 'MEDIO',
      thTax: 'IMPUESTO',
      thToPay: 'A PAGAR'
    },

    tooltips: {
      actions: 'Acciones',
      invoice: 'Ver'

    }
  }
}

export default mEditionBillingMyPaymentsInvoiceHistory
